module.exports = {
  api: 'https://api.euresto.io/',
  socketTransport: ["polling", "websocket"],
}





// WEBPACK FOOTER //
// ./public/config/project.config.js